module.exports = __webpack_public_path__ + "img/not_found.ce4dd914.svg";